import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=d0e30b92"
import script from "./contacts.js?vue&type=script&lang=js&external"
export * from "./contacts.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports